<template>
    <page-content>
        <div slot="header">
            <h4 class="page-title-padding">部门报表</h4>
            <div class="picker">
                <el-date-picker
                    class="picker-form"
                    ref="picker"
                    v-model="monthVal"
                    type="month"
                    placeholder="选择"
                    size="mini"
                    :editable='false'
                    :clearable="false"
                    :picker-options="pickerOptions"
                    @change="monthChange"
                    >
                </el-date-picker>
                <div @click="pickerChange" class="picker-format">{{`${assessDate[0]}/${assessDate[1]}`}}</div>
            </div>
            <el-button style="margin-left:20px;" icon="el-icon-download" size="mini" type="primary" :loading="dowLoading" @click="downloadData">导出数据</el-button>
            <el-input placeholder="分" size="mini" v-model="score" style="width:200px;margin-left:20px;">
                <template slot="prepend">低于</template>
                <template slot="append">
                    <el-button size="mini" type="primary" @click="searchClick">搜索</el-button>
                </template>
            </el-input>
        </div>
        <div slot="content">
            <div>
                <el-table v-loading="sectionLoading" @filter-change="filterChange" :data="sectionData" max-height="780" show-summary :summary-method="getSummaries" size="mini">
                    <el-table-column sortable prop="examinee_name" label="被考评人" header-align="center" align="center">
                        <template slot-scope="scope" align-center>
                            <span :style="scope.row.is_attendance === 0 ? 'color:red;' :''">{{scope.row.examinee_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="examiner_name" label="考评人" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="leader_name" column-key="leader_name" :filters="filterData.leader_name || []" label="负责人" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="position_name" column-key="position_name" :filters="filterData.position_name || []" label="岗位" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="group_name" column-key="group_name" :filters="filterData.group_name || []" label="组别" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="department" label="部门" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column sortable prop="score" label="分数" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="flow" label="流程" width="600" header-align="center">
                        <template slot-scope="scope" align-center>
                            <div>
                                <el-steps :active="setStepsValue(scope.row.flow)" finish-status="success">
                                    <el-step title="互评填写" :status="scope.row.flow.isAssessColleagueCompleted ? 'success' : 'wait'"></el-step>
                                    <el-step title="评分表填写" :status="scope.row.flow.isSelfAssessCompleted ? 'success' : 'wait'"></el-step>
                                    <el-step title="考评人确认" :status="scope.row.flow.isExaminerCompleted ? 'success' : 'wait'"></el-step>
                                    <el-step title="负责人确认" :status="scope.row.flow.isLeaderCompleted ? 'success' : 'wait'"></el-step>
                                </el-steps>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="undoForms(scope)" type="text">回退</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import {computeAssessDate} from '@/assets/js/date'
import {downloadExcel} from '@/assets/js/exportdata'
import {multiFilter} from '@/assets/js/filtrate'
export default {
    data(){
        return {
            assessDate:'',
            sectionLoading:false,
            dowLoading:false,
            sectionData:[],                             //部门数据
            score:'',                                   //搜索分数
            filterData:[],                              //筛选数据
            initData:[],                                //初始数据
            tableFilter:[],                             //筛选条件数据
            monthVal:'',                                //月份
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                }
            }
        }
    },
    created(){
        this.assessDate=computeAssessDate()[0].split('/');
        this.monthVal=this.assessDate[1];
        this.getInitData();
    },
    methods:{
        getInitData(score=''){                                     //初始部门数据
            this.sectionLoading=true;
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                department_id:this.$store.state.login.userinfo.department_id,
                score,
            }
            this.$http.get('/export/getOneDepartmentExportData',{params:param}).then(v=>{
                if(v.status === 200 && v.data.status){
                    this.sectionData=v.data.data;
                    this.initData=JSON.parse(JSON.stringify(v.data.data));
                    if(this.tableFilter.length) this.filterChange(false);
                    this.setAllFilterData(JSON.parse(JSON.stringify(v.data.data)));
                }else{
                    this.sectionData=[];
                    this.initData=[];
                    this.tableFilter=[];
                }
                this.sectionLoading=false;
            }).catch(v=>{this.sectionLoading=false;})
        },
        filterChange(data){                                         //筛选
            const initData = JSON.parse(JSON.stringify(this.initData));
            const val=Object.keys(data);
            if(data){
                if(this.tableFilter.length===0){        //保存全部筛选数据
                    this.tableFilter.push(data)
                }else{
                    let isKey=true;
                    this.tableFilter.forEach((v,index)=>{
                        const $key=Object.keys(v)
                        if(val[0] === $key[0]) isKey=index;
                    })
                    isKey===true ? (this.tableFilter.push(data)) : (this.tableFilter.splice(isKey,1,data))
                }
            }
            this.sectionData=multiFilter(initData,this.tableFilter);
        },
        setAllFilterData(data){                                 //获得筛选数据
            let filterData={ //初始所需数据
                group_name:[],
                position_name:[],
                leader_name:[],
            };
            for(let i in filterData){
                data.forEach(v=>{
                    if(!filterData[i].some(item=>item.text===v[i])){
                        filterData[i].push({
                            text:v[i],
                            value:v[i],
                        });
                    }
                })
            }
            this.filterData=filterData;
        },
        getSummariesCompany(){
            return [`共${this.companyData.length}条数据`]
        },
        searchClick(){                                          //搜索
           this.getInitData(this.score)
        },
        undoForms(scope){                                       //撤销流程
            this.$confirm('此操作将流程回退, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.put('/flow/undo',{assessment_id:scope.row.assessment_id}).then(v=>{
                    if(v.status === 200 && v.data.status){
                        this.getInitData();
                        this.$message({message:v.data.message,type:'success'});
                    }
                }).catch(v=>{})
            }).catch(() => {});
        },
        setStepsValue(data){                                    //设置流程数据
            if(data.isLeaderCompleted){
                return 4;
            }else if(data.isExaminerCompleted){
                return 3;
            }else if(data.isSelfAssessCompleted){
                return 2;
            }else if(data.isAssessColleagueCompleted){
                return 1;
            }
            return 0;
        },
        downloadData(){                                          //导出excel
            const param={
                start:this.assessDate[0],
                end:this.assessDate[1],
                score:this.score,
                department_id:this.$store.state.login.userinfo.department_id,
            }
            this.dowLoading=true;                               
            downloadExcel('get','/export/oneDepartment',{params:param},`${this.assessDate[0]}/${this.assessDate[1]}期部门报表`,v=>{
                this.dowLoading=false; 
            })
        },
        getSummaries(){                                         //页尾
            return [`共${this.sectionData.length}条数据`]
        },
        monthChange(v){         //月份选择
            this.assessDate=computeAssessDate(v)[1].split('/');
            this.getInitData(this.score);
        },
        pickerChange(){
            this.$refs.picker.$el.firstElementChild.focus();
        }
    },
    components:{
        pageContent
    },
}
</script>
<style>
.el-date-picker .el-month-table .today .cell{
    color: #606266;
    font-weight: 500;
}
</style>
<style scoped>
    .picker{
        width: 220px;
        display: inline-block;
        position: relative;
    }
    .picker-format{
        position: absolute;
        background: #ffffff;
        font-size: 12px;
        top: 6px;
        left: 30px;

    }
</style>

